/**
 * Status Indicator Component
 * Toont de huidige status van de opname met visuele feedback
 */

import React from 'react';
import { ConversationStatus } from '../types/models';
import './StatusIndicator.css';

interface StatusIndicatorProps {
  status: ConversationStatus;
  duration: number;
  isPaused?: boolean;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({ 
  status, 
  duration,
  isPaused = false,
}) => {
  const getStatusBadge = () => {
    switch (status) {
      case ConversationStatus.Draft:
        return {
          icon: '📝',
          text: 'Klaar om te starten',
          className: 'draft',
        };
      case ConversationStatus.Recording:
        if (isPaused) {
          return {
            icon: '⏸️',
            text: 'Gepauzeerd',
            className: 'paused',
          };
        }
        return {
          icon: '🔴',
          text: 'Opname bezig...',
          className: 'recording',
        };
      case ConversationStatus.Processing:
        return {
          icon: '⏳',
          text: 'Bezig met uploaden...',
          className: 'processing',
        };
      case ConversationStatus.Completed:
        return {
          icon: '✅',
          text: 'Opgeslagen!',
          className: 'completed',
        };
      case ConversationStatus.Failed:
        return {
          icon: '❌',
          text: 'Mislukt',
          className: 'failed',
        };
    }
  };

  const badge = getStatusBadge();
  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;

  return (
    <div className="status-indicator">
      <div className={`status-badge ${badge.className}`}>
        <span className="status-icon">{badge.icon}</span>
        <span>{badge.text}</span>
      </div>

      {status === ConversationStatus.Recording && (
        <div className={`recording-timer ${isPaused ? 'paused' : ''}`}>
          {minutes}:{seconds.toString().padStart(2, '0')}
        </div>
      )}
    </div>
  );
};